import React, { useState, useRef, useEffect } from "react";

import threedots from "../../../assets/three-dots.svg";

import { DELETE_SURVEY_DIALOG_TEXT } from "../../../constants/constants";
import { extendedApiWrapper } from "../../../services/api-handlers";
import { useAppSelector } from "../../../store/hooks";

import DeleteDialog from "../../dialog/delete-dialog";

import styles from "./styles.module.css";

const ActionMenu = ({ survey }: { survey: string }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { surveys } = useAppSelector((state) => state.surveys);
    const toggleMenu = () => {
        setIsOpen((prev) => !prev);
    };
    const confirmDelete = () => {
        setIsModalOpen(true);
        setIsOpen(false);
    };

    const currentSurvey = surveys.find((item) => item.confirmit_pid === survey);

    const handleSurveyAction = async (action: "update" | "delete") => {
        if (!currentSurvey?.survey_id) {
            return;
        }

        try {
            if (action === "update") {
                await extendedApiWrapper.updateDemographicData(currentSurvey.survey_id);
            } else {
                await extendedApiWrapper.deleteSurveyData(currentSurvey.survey_id);
                setIsModalOpen(false);
            }
            setIsOpen(false);
        } catch (error) {
            console.error(`Error during ${action} action:`, error);
        }
    };
    const handleRemove = () => {
        handleSurveyAction("delete");
    };
    const handleClose = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={styles.menuContainer} ref={menuRef}>
            <button className={styles.menuButton} onClick={toggleMenu}>
                <img src={threedots} alt="menu" />
            </button>

            {isOpen && (
                <div className={styles.menuDropdown}>
                    <button className={styles.menuItem} onClick={confirmDelete}>
                        DELETE
                    </button>
                    <button className={styles.menuItem} onClick={() => handleSurveyAction("update")}>
                        UPDATE DEMOGRAPHIC DATA
                    </button>
                </div>
            )}

            {isModalOpen && <DeleteDialog open={isModalOpen} handleCancel={handleClose} onClose={handleClose} text={DELETE_SURVEY_DIALOG_TEXT} handleRemove={handleRemove} removeText="Delete" />}
        </div>
    );
};

export default ActionMenu;
